import { accountSelectedSelector } from 'atoms';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

function MainPage() {
  const accountSelected = useRecoilValue(accountSelectedSelector);

  if (!accountSelected) {
    return <Navigate to={`/summary`} replace />;
  }

  return <Navigate to={`/place`} replace />;
}

export default MainPage;
